import Vue from 'vue'
import VueRouter from 'vue-router'
import {menusNames as mn} from "./constants/menus";

Vue.use(VueRouter);

import Home from "./components/Home";
import Editors from "./components/Editors";
import Editor from "./components/Editor";
import EditorDetail from "./components/EditorDetail";
import Featured from "./components/Featured";
import FeaturedDetail from "./components/FeaturedDetail";
import News from "./components/News";
import NewsDetail from "./components/NewsDetail";
import Contacts from "./components/Contacts";
import OurStory from "./components/OurStory";
import PlayerDetail from "./components/PlayerDetail";

let routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
    },
    {
        path: '/our-story',
        name: 'our-story',
        component: OurStory,
    },
];

let jsonRoutes = jsonData.routes;

for (var id in jsonRoutes) {
    let link = jsonRoutes[id].link
    let part = null

    if (id === mn.EDITORS) {
        part = [
            {
                //path: '/editors',
                path: link,
                name: 'editors',
                component: Editors,
            },
            {
                path: link + '/:editor(.+)',
                name: 'editor',
                component: Editor,
                children: [
                    {
                        path: ':reel',
                        name: 'editor-reel',
                        component: EditorDetail,
                        children: [
                            {
                                path: ':detail',
                                name: 'editor-detail',
                                component: PlayerDetail,
                                meta: {scrollToTop: true},
                            },
                        ]
                    },
                ]
            },
        ]
    } else if (id === mn.FEATURED_WORK) {
        part = [
            {
                //path: '/featured-work',
                path: link,
                name: 'featured',
                redirect: {name: 'features'},
                component: Featured,
                children: [
                    {
                        path: '',
                        name: 'features',
                        component: FeaturedDetail,
                    },
                    {
                        path: ':reel',
                        name: 'featured-reel',
                        component: FeaturedDetail,
                        //meta: {scrollToTop: true},
                        children: [
                            {
                                path: ':detail',
                                name: 'featured-detail',
                                component: PlayerDetail,
                                meta: {scrollToTop: true},
                            },
                        ]
                    },
                ]
            },
        ]
    } else if (id === mn.NEWS) {
        part = [
            {
                //path: '/news',
                path: link,
                name: 'news',
                component: News,
            },
            {
                path: link + '/:detail',
                name: 'news-detail',
                component: NewsDetail,
                meta: {scrollToTop: true},
            },
        ]
    } else if (id === mn.CONTACT) {
        part = [
            {
                //path: '/contacts',
                path: link,
                name: 'contacts',
                component: Contacts,
            },
        ]
    }

    if (part) {
        routes = routes.concat(part)
    }
}

routes.push({
    path: '*',
    name: 'not-found',
    redirect: {name: 'home'}
})

const scrollBehavior = function (to, from, savedPosition) {
    //console.log('scrollBehavior', to, from)
    let position = {}

    return new Promise(resolve => {
        //debugger
        if (to.matched.some(m => m.meta.scrollToTop)) {
            position.x = 0
            position.y = 0
        }

        if (to.name === 'news') {
            position = to.meta && to.meta.position || {}
        }

        this.app.$root.$once('triggerScroll', () => {
            resolve(position)
        })
    })
}

const base = process.env.NODE_ENV === 'ihouse'
    ? '/cms/app/'
    : '/'

const router = new VueRouter({
    routes: routes,
    scrollBehavior,
    mode: 'history',
    base: base,
})

if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}

router.beforeEach(async (to, from, next) => {
    //console.log('app: beforeEach', from)

    if (from.name === 'news') {
        from.meta.position = {x: window.scrollX, y: window.scrollY}
    }

    next()
})

export default router;
